import { css } from "@emotion/react";
import { FetchDEIHubContentResponse } from "../../../../../libs/api-service/src/lib/cms";
import StrapiMarkdown from "../Strapi/Markdown";
import HubSectionTile from "./SectionTile";
import { useRouter } from "next/router";
import {
  GTMEventName,
  pushGtmEvent,
  GTMTrackingResource,
} from "apps/dashboard-client/utils/googleTagManagerUtils";
import { respond } from "../../../styles/mixins";

type HubContentPageProps = FetchDEIHubContentResponse;

const s = {
  mainContainer: css({
    display: "flex",
    flexDirection: "column",
    rowGap: "3.2rem",
  }),

  header: css({
    display: "flex",
    flexDirection: "column",
    rowGap: "1.2rem",
  }),
  hubSections: css(
    {
      display: "grid",
      justifyItems: "center",
      gridTemplateColumns: "1fr 1fr 1fr",
      gap: "2.4rem",
    },
    respond(
      "m",
      css({
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
      })
    ),
    respond(
      "xl",
      css({
        gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
      })
    )
  ),
};

const HubMainPage = ({
  title,
  hub_sections,
  header_body,
}: HubContentPageProps) => {
  const router = useRouter();

  return (
    <div css={s.mainContainer}>
      <div css={s.header}>
        <h2>{title}</h2>
        <StrapiMarkdown
          text={header_body}
          linkTrackingEvent={{
            event: GTMEventName.RESOURCE_READ,
            resource: GTMTrackingResource.HUB,
            data: {
              section: "Hub main page",
            },
          }}
        />
      </div>
      <div css={s.hubSections}>
        {hub_sections?.map((section) => (
          <HubSectionTile
            key={section.id}
            {...section}
            onClick={() => {
              router.push(
                `/hub/${section.slug}/${section.hub_subsections[0].slug}`
              );
              pushGtmEvent({
                event: GTMEventName.RESOURCE_READ,
                resource: GTMTrackingResource.HUB,
                data: { section: section.title },
              });
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default HubMainPage;
